'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = require('./helpers'),
    cf = _require.cf,
    calcPath = _require.calcPath,
    goalPath = _require.goalPath;

function path(state, constants) {
  var returns = [0].concat(_toConsumableArray(Array(state.spendStartAge - state.age).fill(1 + constants.investmentPeriodReturn)), _toConsumableArray(Array(state.spendStopAge - state.spendStartAge).fill(1 + constants.spendingPeriodReturn)));

  var valueOfRegularInvestments = [0].concat(_toConsumableArray(Array(state.investStartAge - state.age).fill(0)), _toConsumableArray(cf(constants.regularInvestment, state.inflation, 0, state.investStopAge - state.investStartAge, constants.k)), _toConsumableArray(Array(state.spendStopAge - state.investStopAge).fill(0)));

  var regularInvestments = [].concat(_toConsumableArray(Array(state.investStartAge - state.age).fill(0)), _toConsumableArray(cf(constants.regularInvestment, state.inflation, 0, state.investStopAge - state.investStartAge, 12)), _toConsumableArray(Array(state.spendStopAge - state.investStopAge).fill(0)));

  var spendOutflows = [0].concat(_toConsumableArray(Array(state.spendStartAge - state.age).fill(0)), _toConsumableArray(constants.spendOutflows));

  var goalPathValues = calcPath(returns, state.startingAllocation, valueOfRegularInvestments, spendOutflows);

  return {
    goalPath: goalPath(state.age, goalPathValues, 'Portfolio Value'),
    regularInvestments: goalPath(state.age, regularInvestments, 'Monthly Investment')
  };
}

module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cmw-goaltools/dist/lib/path.js
// module id = 221
// module chunks = 0